import { Flex, Img } from '@chakra-ui/react'
import { ModalBase } from '../../../../../components/ModalBase'
const LoadingGif = 'https://sigah.blob.core.windows.net/assets/front/Loading%20SAH.gif'

interface iModalComunicacao {
  isOpen: boolean
}

export const ModalIniciando: React.FC<iModalComunicacao> = ({ isOpen }) => {
  return (
    <ModalBase Titulo='Iniciando feedback, aguarde!' isOpen={isOpen} onClose={() => {}} disabledHeader>
      <Flex maxW={'32rem'} px={'4rem'} pb={'2rem'} flexDir='column' alignItems={'center'}>
        <Img src={LoadingGif} w={'28rem'}/>
      </Flex>
    </ModalBase>
  )
}
